import { render, staticRenderFns } from "./FilterShare.vue?vue&type=template&id=b230eb54&scoped=true"
import script from "./FilterShare.vue?vue&type=script&lang=js"
export * from "./FilterShare.vue?vue&type=script&lang=js"
import style0 from "./FilterShare.vue?vue&type=style&index=0&id=b230eb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b230eb54",
  null
  
)

export default component.exports